import { store } from '@/decorators/store';
import { ResponseProfile } from '@/entities/ResponseProfile';
import { AbstractEntityStore } from '@/stores/AbstractEntityStore';

@store({ id: 'ResponseProfile' })
export class ResponseProfileStore extends AbstractEntityStore<ResponseProfile> {
  protected entityIdKey = 'responseProfileId';
  protected entityLabelKey = 'responseProfileName';
  protected entityValueKey = 'responseProfileName';
}
